module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("An Amish Christmas")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0005-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_c('i', [_vm._v("Glossary")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0005-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("ab im kopp ")]), _vm._v("– off in the head, crazy")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("aenti ")]), _vm._v("– aunt")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("baremlich ")]), _vm._v("– terrible")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("bauchduch ")]), _vm._v("– napkin")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("boppli ")]), _vm._v("– baby or babies ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("bruder ")]), _vm._v("– brother")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("daadi ")]), _vm._v("– grandfather")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("daed ")]), _vm._v("– dad")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("danki ")]), _vm._v("– thanks")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("demut ")]), _vm._v("– humility")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("dippy eggs ")]), _vm._v("– eggs cooked over easy")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("Derr Herr ")]), _vm._v("– God")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("dochder ")]), _vm._v("– daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("du bischt wilkumm ")]), _vm._v("– you’re welcome")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("dummkopf ")]), _vm._v("– dummy")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("Englisch ")]), _vm._v("or "), _c('i', [_vm._v("Englischer ")]), _vm._v("– a non-Amish person")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("fraa ")]), _vm._v("or "), _c('i', [_vm._v("frau ")]), _vm._v("– wife")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("Frehlicher Grischtdaag ")]), _vm._v("– Merry Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("gebet ")]), _vm._v("– prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("gern schöna ")]), _vm._v("– so willingly done")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("glay hotsli ")]), _vm._v("– little heart (endearment)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("grossmammi ")]), _vm._v("– grandmother")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("guder mariye ")]), _vm._v("– good morning")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("guten nacht ")]), _vm._v("– good night")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("gut-n-owed ")]), _vm._v("– good evening")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("gutguckich ")]), _vm._v("– good-looking")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("gut ")]), _vm._v("– good")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("halt ")]), _vm._v("– stop")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("haus ")]), _vm._v("– house")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("hatt ")]), _vm._v("– hard")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0006-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_c('i', [_vm._v("herr ")]), _vm._v("– mister")])])]), _c('a', {
    attrs: {
      "id": "pagevi"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("hochmut ")]), _vm._v("– pride")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("in lieb ")]), _vm._v("– in love")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("kaffi ")]), _vm._v("– coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("kapp ")]), _vm._v("– prayer covering or cap")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("kind, kinder, kinner ")]), _vm._v("– children or grandchildren")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("liebschen ")]), _vm._v("– dearest")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("maedel ")]), _vm._v("or "), _c('i', [_vm._v("maed ")]), _vm._v("– girl or girls")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("mamm ")]), _vm._v("– mom")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("mammi ")]), _vm._v("– grandmother")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("mann ")]), _vm._v("– man")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("mei ")]), _vm._v("– my")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("mudder ")]), _vm._v("– mother")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("naerfich ")]), _vm._v("– nervous")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("narrisch ")]), _vm._v("– crazy")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("nee ")]), _vm._v("– no")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("onkel ")]), _vm._v("– uncle")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("ordnung ")]), _vm._v("– the written and unwritten rules of the Amish; the understood behavior by which the Amish are expected to live, passed down from generation to generation. Most Amish know the rules by heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0006-02-2"
    }
  }, [_c('span', [_vm._v("Pennsylvania "), _c('i', [_vm._v("Deitsch ")]), _vm._v("– Pennsylvania German, the language most commonly used by the Amish")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("recht ")]), _vm._v("– right")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("redd-up ")]), _vm._v("– clean up")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("rumschpringe ")]), _vm._v("– running-around period when a teenager turns sixteen years old")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("sehr gut ")]), _vm._v("– very good")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("seltsam ")]), _vm._v("– weird")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("sohn ")]), _vm._v("– son")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("wunderbaar ")]), _vm._v("– wonderful")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', [_c('i', [_vm._v("ya ")]), _vm._v("– yes ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 72
// module chunks = 0